var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicebarDropdownOpenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4657 1.461C1.35916 1.35447 1.18643 1.35447 1.0799 1.461C0.973367 1.56753 0.973367 1.74027 1.0799 1.8468L6.5343 7.3012C6.64084 7.40774 6.81357 7.40774 6.9201 7.3012L12.3745 1.8468C12.481 1.74027 12.481 1.56753 12.3745 1.461C12.268 1.35447 12.0952 1.35447 11.9887 1.461L6.72472 6.72499L1.4657 1.461Z",
    fill: "black",
    stroke: "#09414E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicebarDropdownOpenArrow);
export default __webpack_public_path__ + "static/media/invoicebar-dropdown-open-arrow.2af7e6d303231a0efa6d0378fac554f0.svg";
export { ForwardRef as ReactComponent };